
export const getBoolean = (boolean: string): boolean => {
  return boolean === "true";
};
